import React, { useState } from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { DialogContent, DialogActions } from 'Views/Page/Content/Modal/Components';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDPrimaryActionButton, FDPrimaryActionIconButton, FDStack } from '@facet-wealth/design';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { dataAttrs } from 'Helpers/Testing';
import { RealAssetMetaLayout } from './metaLayout';

const overrides = buildFacetDesignOverride();

export const MissingRealAssetsDetailsTemplate = () => {
  const { loadModalCollectionByLink } = useModalContext();
  const { resource, onSubmit: wizardSubmit } = useMetaLayoutContext();
  const [saving, setSaving] = useState(false);
  const { displayErrorMessage } = useSnackbarContext();
  const [currentAssetIndex, setCurrentAssetIndex] = useState(0);
  const currentAsset = resource.attr('realAssets').resources().index(currentAssetIndex);

  const onSubmit = async () => {
    setSaving(true);
    try {
      await currentAsset.submit();
      if (currentAssetIndex + 1 === resource.attr('realAssets').resources().length()) {
        await wizardSubmit();
        setSaving(false);
        return;
      }
      setCurrentAssetIndex(index => index + 1);
      setSaving(false);
    } catch (err) {
      setSaving(false);
      displayErrorMessage(err, err.errors);
    }
  };

  const onBack = currentAssetIndex > 0
    ? () => setCurrentAssetIndex(index => index - 1)
    : resource.withRelationship(
      fr.relationships.previousLink.name,
      (rel) => () => loadModalCollectionByLink(rel.link('related').url()),
      () => undefined,
    );

  return (
    <>
      <MetaControlField attr={'title'} />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction="column" spacing={3} paddingY={1}>
          <MetaFormInline
            resource={currentAsset}
            metaOverrideSet={overrides}
            layout={RealAssetMetaLayout}
            padding="none"
            margin="none"
            noIndividualSubmitButtons
            noIndividualDeleteButtons
          />
        </FDStack>
      </DialogContent>
      <DialogActions>
        {onBack ? <FDPrimaryActionIconButton icon="chevronLeft" onClick={onBack} /> : null}
        <FDPrimaryActionButton
          {...dataAttrs('continue-btn', resource)}
          label="Continue →"
          onClick={onSubmit}
          loading={saving}
        />
      </DialogActions>
    </>
  );
};
